import { Backdrop, CircularProgress } from '@mui/material';
import axiosServices from '@utils/axios';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

const AcceptShareRequestPage = () => {
  const { id, studyType } = useParams();

  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const token = urlParams.get('token');
  const notificationId = urlParams.get('notification_id');
  const navigate = useNavigate();
  React.useEffect(() => {
    const accepturl = `${import.meta.env.VITE_BACKEND_URL}/${studyType}/accept-share-request/${id}${studyType === 'survey' ? '' : '/'}?token=${token}&notification_id=${notificationId}`;
    const studyUrl = `/${studyType === 'dynamic-surveys' ? 'dynamic-survey' : 'interview'}/${id}/${studyType === 'dynamic-surveys' ? 'response-insight' : 'transcripts'}`;
    const acceptShareRequest = async () => {
      try {
        const response = await axiosServices.post(accepturl);
        if (response.status === 200) {
          // toast.success('Share request accepted successfully');
          localStorage.removeItem('acceptShareRequestUrl');
          setTimeout(() => {
            navigate(studyUrl);
          }, 1000);
        } else {
          // toast.error('Please sign in to accept the share request');
          localStorage.setItem('acceptShareRequestUrl', window.location.href);
          setTimeout(() => {
            navigate('/signin');
          }, 1000);
        }
      } catch (error) {
        // toast.error(error.detail);
        localStorage.setItem('acceptShareRequestUrl', window.location.href);
        navigate('/signin');
      }
    };

    acceptShareRequest();
  }, []);

  return (
    <div>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open>
        <CircularProgress color="primary" />
      </Backdrop>
    </div>
  );
};

export default AcceptShareRequestPage;
